(function ($) {
    
    function initSlider() {
        $( '.js-slider' ).each( function() {
            $( this ).slick( {
                autoplay: true,
                autoplaySpeed: 7000,
                cssEase: 'ease',
                lazyLoad: 'progressive',
                dots: false,
                fade: true,
                speed: 500,
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                pauseOnFocus: false,
                pauseOnHover: false,
                infinite: true,
                adaptiveHeight: false,
                appendArrows: $(this).parents('.hero-slider').find('.hero-arrows-inner')
            });
        });
    }
    /* Document Ready */
	$(document).ready(function() {
        initSlider();
	});

})(jQuery);